import styled from '@emotion/styled';
import { ContentBanner, ContentBannerProps } from '@modernhealth/vital-components';
import { mediaQuery } from '@modernhealth/vital-foundation';

import { linearGradient } from './CirclesBanner';

const InternationalCirclesImage =
    'https://assets.joinmodernhealth.com/circles/hero/international-circles-hero.png';

// Banner gradiant for tablet and desktop screen sizes
const bannerGradient = linearGradient(
    89.77,
    ['rgba(40, 86, 73, 1)', 'max(250px, 42%)'],
    ['rgba(47, 107, 90, 0.38)', 0.7],
    ['rgba(72, 122, 108, 0)', 0.9],
);
// Banner gradient for medium screens
const bannerGradientMd = linearGradient(
    89.77,
    ['rgba(40, 86, 73, 1)', 0.36],
    ['rgba(47, 107, 90, 0.38)', 0.75],
);
// Banner gradient for small screens
const bannerGradientSm = linearGradient(
    89.77,
    ['rgba(40, 86, 73, 1)', 'max(100px, 40%)'],
    ['rgba(47, 107, 90, 0.38)', 0.64],
);

// Emotion needs us to indicate which props should be passed to React
const allowedProps = [
    'backgroundColor',
    'theme',
    'title',
    'description',
    'buttonTitle',
    'linkTo',
    'onClick',
] as const;

type AllowedProps = (typeof allowedProps)[number];

const BannerBase = styled<React.FC<Pick<ContentBannerProps, AllowedProps>>>(ContentBanner, {
    shouldForwardProp: propName => allowedProps.includes(propName as AllowedProps),
})({
    backgroundImage: `${bannerGradient}, url(${InternationalCirclesImage})`,
    backgroundPosition: 'right',
    [mediaQuery.maxWidth('md')]: {
        backgroundImage: `${bannerGradientMd}, url(${InternationalCirclesImage})`,
        backgroundPosition: '0 0, 150px 33%',
        backgroundSize: '100% 100%, cover',
    },
    [mediaQuery.maxWidth('sm')]: {
        backgroundImage: `${bannerGradientSm}, url(${InternationalCirclesImage})`,
        backgroundPosition: '0 0, 125px 33%',
        backgroundSize: '100% 100%, cover',
    },
    [mediaQuery.maxWidth('xs')]: {
        backgroundPosition: '0 0, 50px 33%',
        backgroundSize: '100% 100%, cover',
    },
    // Fallback to solid color on very small screens
    '@media only screen and (max-width: 300px)': {
        background: 'rgba(40, 86, 73, 1)',
    },
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%, contain',
    // !important is required to override the ContentBanner's minHeight
    // TODO: Expose "primitive" versions of containers in Vita (e.g. BannerPattern)
    minHeight: '283px !important',
    width: '100%',
});

export const CirclesInternationalBanner: React.FC<{
    title: string;
    description: string;
    buttonTitle: string;
}> = props => {
    return (
        <BannerBase
            backgroundColor="gray85"
            theme={'light' as unknown as undefined}
            onClick={() => undefined}
            linkTo="/circles/on-demand"
            {...props}
        />
    );
};
